export default __webpack_public_path__ + "static/media/image16.86ea6552.png";